export declare type BoelsUser = {
  type: UserEnum;
  debtor?: Debtor;
  userId?: string;
  b2cToken?: string;
  sapAuthToken?: string;
};

export type Debtor = {
  firstName?: string;
  language?: string;
  lastName?: string;
  name?: string;
  preferencesToken?: string;
  profile?: string;
  salutation?: string;
  addresses?: Array<unknown>;
  contactInfo?: Array<DebtorContactInfo>;
  accounts: Array<DebtorAccount>;
};

type DebtorContactInfo = {
  classification?: string;
  type?: string;
  value?: string;
};

export type DebtorAccount = {
  debtorNumber: string;
  name: string;
  displayValue: string;
  nameExtraInfo?: string;
  addresses: Array<AccountAddres>;
};

export type AccountAddres = {
  city?: string;
  country?: string;
  street?: string;
  type?: string;
  zipcode?: string;
};

export enum UserEnum {
  ANONYMOUS,
  GUEST,
  B2C_AUTHENTICATED,
}
